import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { InventarService } from 'src/app/core/services/inventar.service';
import { ProductService } from 'src/app/core/services/product.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import {
  debounceTime,
  distinctUntilChanged,
  skipWhile,
  switchMap,
  tap,
} from 'rxjs/operators';
import { FormControl, NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { CompanyService } from 'src/app/core/services/company.service';
import { ICompany } from 'src/app/core/models/company.model';

@Component({
  selector: 'app-inventar-products',
  templateUrl: './inventar-products.component.html',
  styleUrls: ['./inventar-products.component.css'],
})
export class InventarProductsComponent implements OnInit {
  companyId: string;
  filialId: string;
  inventarId: string;
  products: any;
  page = 1;
  perPage = 10;
  inventar: any;
  toggleProduct = false;
  selectedProduct: any;
  filial: any;
  company: any;
  currentUser: any;
  searchParam: string;
  userList: any;
  selectedUserId = undefined;
  toggleDateError = false;
  isLoading = true;
  selectedStatus: string = '';
  toggleStatusProduct = false;
  @ViewChild('filter') filter: ElementRef;
  dateFrom = null;
  dateTo = null;

  statusOptions = [
    { name: 'active', isChecked: false },
    { name: 'finished', isChecked: false },
    { name: 'cancelled', isChecked: false },
  ];

  get lower() {
    return this.perPage * (this.page - 1) + 1;
  }

  get upper() {
    return Math.min(this.perPage * this.page, this.products.totalCount);
  }

  myControl = new FormControl();
  formCtrlSub: Subscription;

  searchControlUsername = new FormControl();
  formCtrlSub2: Subscription;
  searchUsername: string;

  companies: ICompany[];
  isAllProducts: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private productService: ProductService,
    private inventarService: InventarService,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    public toastr: ToastrService,
    private translate: TranslateService,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    this.route.parent.params.subscribe((res) => {
      this.companyId = res.id;
      this.filialId = res.filialId || this.route.snapshot.params.filialId;
    });

    this.route.parent.data.subscribe((res) => {
      this.filial = res.filial;
    });

    if (this.currentUser.role.name === 'root' && this.router.url.includes('/root/products')) {
      this.isAllProducts = true;
    }

    if (this.currentUser.role.name === Role.ROOT && !this.isAllProducts) {
      this.route.parent.parent.parent.data.subscribe((res) => {
        this.company = res.company;
        this.companyId = this.company?.id;
      });
    }

    this.inventarId = this.route.snapshot.params.inventarId;

    if (this.currentUser.role.name === Role.WORKER) {
      this.selectedUserId = this.currentUser.id;
    }


    this.loadProducts();

    if (this.currentUser.role.name !== Role.WORKER) {
      if(!this.isAllProducts) {
        this.loadInventar();
        this.loadUsers();
      } else {
        this.companyService.getCompanies().subscribe(res => {
          this.companies = res;
        })
      }
    } else {
      this.inventarService.selectedInventar
        .pipe(skipWhile((value) => value === null))
        .subscribe(
          (res) => {
            this.inventar = res;
            // this.breadcrumbService.set('@companyName', this.company?.name);
            // this.breadcrumbService.set('@filialName', this.filial.name);
            this.breadcrumbService.set('@productName', this.inventar.name); // path for MentorDetailsComponent contains param (:id)
          },
          (err) => {}
        );
    }

    this.formCtrlSub = this.myControl.valueChanges
      .pipe(
        debounceTime(800),
        distinctUntilChanged(),
        tap((value) => {
          this.isLoading = true;
          this.searchParam = value;
          this.page = 1;
        }),
        switchMap((changedValue) => this.getProducts())
      )
      .subscribe((res) => {
        this.products = res;
        this.findPreviewImage(this.products.results);
        this.isLoading = false;
      });

      this.formCtrlSub2 = this.searchControlUsername.valueChanges
        .pipe(
          debounceTime(800),
          distinctUntilChanged(),
          tap((value) => {
            this.isLoading = true;
            this.searchUsername = value;
            this.page = 1;
          }),
          switchMap((changedValue) => this.getProducts())
        )
        .subscribe((res) => {
          this.products = res;
          this.findPreviewImage(this.products.results);
          this.isLoading = false;
        });
  }

  onSelectionChange(selectedOption: any) {
    if(selectedOption) {
      this.companyId = selectedOption.id;
    } else {
      this.companyId = null;
    }
    this.page = 1;
    this.loadProducts();
  }

  getProducts(): Observable<any> {
    if(this.isAllProducts) {
      return this.productService.getAllProducts(this.page, this.perPage, this.companyId, this.searchParam, this.searchUsername)
    } else {
      const statusOptions = this.statusOptions
      .filter((status) => status.isChecked)
      .map((status) => status.name);
    return this.productService.getInventarProducts(
      this.inventarId,
      this.page,
      this.perPage,
      this.searchParam,
      this.selectedUserId,
      this.dateFrom,
      this.dateTo,
      statusOptions
    );
    }
    
  }

  loadProducts() {
    this.isLoading = true;

    this.getProducts().subscribe(
      (res) => {
        this.products = res;
        this.findPreviewImage(this.products.results);
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  findPreviewImage(products) {
    if (!products.length) {
      return;
    }

    products.forEach((product) => {
      if (product.images.length) {
        const img = product.images.find((img) => img.type === 'regular');
        const scanned = product.images.find((img) =>
          ['barcode', 'qrcode', 'vin'].includes(img.type)
        );

        product.previewImage = img ? img : null;
        product.scannedImage = scanned ? scanned : null;
      }
    });
  }

  loadInventar() {
    this.inventarService
      .getFilialInventarById(this.filialId, this.inventarId)
      .subscribe(
        (res) => {
          this.inventar = res;
          this.breadcrumbService.set('@companyName', this.company?.name);
          this.breadcrumbService.set('@filialName', this.filial?.name);
          this.breadcrumbService.set('@productName', this.inventar.name); // path for MentorDetailsComponent contains param (:id)
        },
        (err) => {}
      );
  }

  loadUsers() {
    if (this.currentUser.role.name !== Role.ROOT) {
      this.companyId = this.currentUser.companyId;
    }
    this.inventarService
      .getFilialInventarWorkers(this.filialId, this.inventarId)
      .subscribe((res) => {
        this.userList = res;
      });
  }

  seeProduct(product) {
    this.selectedProduct = product;
    this.toggleProduct = true;
  }

  jumpToPage(event: any) {
    this.page = event;
    if(this.isAllProducts) {
      this.loadProducts();
    } else {
      this.searchProduct();
    }
  }
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  hoveredDate: NgbDate | null = null;
  onDateSelection(date: NgbDate, datepicker: any) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date;
      datepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    setTimeout(() => {
      this.searchProduct();
    }, 200);
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    if (input === '') {
      currentValue = null;
    }
    setTimeout(() => {
      this.searchProduct();
    }, 200);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  lastWeek() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
    this.toDate = this.calendar.getToday();
    this.searchProduct();
  }

  lastMonth() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'm', 1);
    this.toDate = this.calendar.getToday();
    this.searchProduct();
  }

  searchProduct() {
    const from = (document.getElementById('fromDate') as HTMLInputElement)
      ?.value;

    if (from !== '') {
      let fromDate = moment(
        from,
        ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD'],
        true
      );

      if (!fromDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      this.dateFrom = new Date(fromDate.format('YYYY-MM-DD')).toISOString();
    }

    const to = (document.getElementById('toDate') as HTMLInputElement)?.value;
    let t = '';

    if (to !== '') {
      let toDate = moment(to, ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY.MM.DD'], true);

      if (!toDate.isValid()) {
        this.toggleDateError = true;
        return false;
      }

      t = new Date(toDate.format('YYYY-MM-DD')).toISOString();
      this.dateTo = t.substring(0, t.indexOf('T') + 1) + '23:59:59.000Z';
    }

    this.loadProducts();
  }

  deleteProduct(product: any) {
    this.productService.deleteProduct(product.inventarId, product.id).subscribe(
      (res) => {
        this.toastr.success('Product has been removed from inventar.');
        this.loadProducts();
      },
      (err) => {
        this.toastr.error('Product cannot be removed from finished inventar.');
        console.log(err);
      }
    );
  }
  openStatus: boolean;
  openStatusProduct(productData) {
    this.openStatus = productData.open;
    this.toggleStatusProduct = true;
    console.log(productData)
    this.selectedProduct = productData.product;
  }

  changeStatusProduct(status, form: NgForm) {
    let body = {
      status: status,
      reason: form.form.value.reason,
    };

    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return false;
    }
    this.productService
      .updateProduct(this.selectedProduct.inventarId, this.selectedProduct.id, body)
      .subscribe(
        (res) => {
          this.toastr.success('The product status has changed.');
          this.loadProducts();
        },
        (err) => {
          console.log(err);
        }
      );

    this.toggleStatusProduct = false;
  }

  changeStatus(index: number, event: any) {
    this.statusOptions[index].isChecked = event.target.checked;
    setTimeout(() => {
      this.searchProduct();
    }, 400);
  }

  editProduct(form: NgForm) {
    const editData = form.form.value;

    if (!form.valid) {
      this.toastr.error('Fill required fields.')
      return;
    }

    let body = {};

    Object.keys(this.selectedProduct).forEach((key) => {
      if (key in editData) {
        if (this.selectedProduct[key] !== editData[key]) {
          body[key] = editData[key] === '' ? null : editData[key];
        }
      }
    });

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      return;
    }

    this.productService
      .updateProduct(this.selectedProduct.inventarId, this.selectedProduct.id, body)
      .subscribe(
        (res) => {
          this.toastr.success('Success.');
          this.loadProducts();
          this.selectedProduct = null;
          this.toggleProduct = false;
        },
        (err) => {
          console.log(err);
        }
      );
  }
}
